export enum CountryCodeEnum {
  UnitedStates = "US",
  GreatBriton = "GB",
  France = "FR",
  Denmark = "DE",
  Canada = "CA",
  Spain = "ESP",
  Nepal = "NP",
}
